import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

// Define the shape of value items
export interface ValueItem {
  header: any;
  value: any;
}

// Extend the component's props to accept an onClick handler
interface AssetValueCardProps {
  title: string;
  values: ValueItem[];
  onClick?: () => void; // Add optional onClick prop
  totalType?: string;
}

const KPICard: React.FC<AssetValueCardProps> = ({
  title,
  values,
  onClick, // Destructure the onClick prop
  totalType = '',
}) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Card
      onClick={onClick} // Apply the onClick event to the Card
      sx={{
        mb: 2,
        cursor: onClick ? 'pointer' : 'default', // Change cursor if onClick is provided
        background: palette.paperBackground,
      }}
    >
      <CardContent>
        <Typography
          sx={{
            color: palette.textPrimary,
          }}
          variant="body2"
          fontSize={12}
        >
          {title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          {values.map((item, index) => (
            <React.Fragment key={index}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: enableDarkTheme ? palette.lightGrey : palette.grey,
                  }}
                >
                  {item.header}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: palette.textPrimary,
                  }}
                >
                  {item.value} {totalType}
                </Typography>
              </Box>

              {index < values.length - 1 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    height: '20px',
                    alignSelf: 'center',
                    borderColor: enableDarkTheme
                      ? palette.lightGrey
                      : palette.grey,
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default KPICard;
